// extracted by mini-css-extract-plugin
export default {"rating":"rating___ECImG","hasText":"hasText___O8PRL"};